import { styled, TextField } from "@mui/material";

const ResponsiveTextField = styled(TextField)(({ theme }) => ({
  [theme.breakpoints.down(500)]: {
    width: "14rem",
  },
}));

export default ResponsiveTextField;
